<div class="container-fluid text-center">
  <div class="col-sm-8 text-start">
    <h2>{{ 'organisation-study.studies' | translate }}</h2>
  </div>

  <div class="row justify-content-center">
    <div class="col-12 col-sm-6 mb-2">
      <mat-form-field [style.width.%]="100" appearance="outline">
        <mat-label>{{ 'organisation-study.search' | translate }}</mat-label>
        <input
          (keyup.enter)="applyStudyFilter(true)"
          [(ngModel)]="filter.searchFilter"
          aria-describedby="groupSearch"
          aria-label="Search"
          matInput
          type="text"
        />
        <button
          [attr.id]="'btnSearchStudy'"
          (click)="applyStudyFilter(true)"
          aria-label="Search"
          mat-button
          matSuffix
        >
          <mat-icon>search</mat-icon>
        </button>
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <app-pagination-list
      #paginator
      (emitPageChange)="updatePagedStudies($event)"
      [_isLoading]="(isLoading$ | async)"
      [_data]="(studiesData$ | async)"
    ></app-pagination-list>

    <div *ngIf="(isLoading$ | async); else elseStudyBlock" class="col-sm">
      <app-loader></app-loader>
    </div>
    <ng-template #elseStudyBlock>
      <div class="col-sm">
        <div *ngFor="let study of (pagedStudies$ | async); trackBy: helper.trackById">
          <app-card-study
            (emitUpdatePerformed)="applyStudyFilter()"
            [_study]="study"
            [_organisations]="organisations"
          ></app-card-study>
        </div>
      </div>
    </ng-template>
  </div>
</div>
